import React from 'react';
import { Navigate } from 'react-router-dom';
import { UserAuth } from '../context/AuthContext';
import { DEMO_MODE } from '../data/demoData';

const ProtectedRoute = ({ children }) => {
  if (DEMO_MODE) {
    return children;
  }
  const { user } = UserAuth();

  if (!user) {
    return <Navigate to='/login' />;
  }
  return children;
};

export default ProtectedRoute;
